import { FeaturesState } from '../app/slices/featuresSlice';
import { get } from './apiUtil';
import { AxiosResponse } from 'axios';

export function getFeatures(): Promise<FeaturesState> {
  return new Promise((resolve, reject) => {
    get('/api/features')
      .then((response: AxiosResponse) =>
        resolve(response.data as FeaturesState)
      )
      .catch((e) => reject(e));
  });
}
